/*
 * Copyright (C) 2025 SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";

const WebsiteLogo = () => {

    return (
        <a
            href='/'
            title='Home'
            rel='home'
            className='logo'
            id='header-logo'
        >
            Home
        </a>
    );
};
export { WebsiteLogo };
